import { render, staticRenderFns } from "./CodeBlog.vue?vue&type=template&id=1c22d36e&scoped=true&"
import script from "./CodeBlog.vue?vue&type=script&lang=js&"
export * from "./CodeBlog.vue?vue&type=script&lang=js&"
import style0 from "./CodeBlog.vue?vue&type=style&index=0&id=1c22d36e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c22d36e",
  null
  
)

export default component.exports